import { render, staticRenderFns } from "./AddReductionRecord.vue?vue&type=template&id=65e937f1&scoped=true"
import script from "./AddReductionRecord.vue?vue&type=script&lang=js"
export * from "./AddReductionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e937f1",
  null
  
)

export default component.exports